<template>
	<div id="getFlowSummary" class="public-content">
		<div class='titleName'>
			现金流量汇总表
		</div>
		<!-- 筛选 -->
		<div class='screen_wrapper'>
			<el-form label-width="80px" inline label-position="left">
				<el-form-item label='会计期间'>
					 <el-date-picker
					  size='mini'
					  class='itemPublic'
				      v-model="dataList"
				      type="monthrange"
              :clearable="false"
				      range-separator="至"
				      @change='getTableData' 
				      start-placeholder="开始月份"
				      end-placeholder="结束月份">
				    </el-date-picker>
				</el-form-item>
				<el-form-item label='科目名称'>
					<el-select v-model="subjectList" placeholder="请选择" size='mini' clearable filterable  @change='getTableData' multiple collapse-tags>
					    <el-option
					      v-for="item in objectList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label='项目名称'>
					<el-select v-model="form.reportFromId" placeholder="请选择" size='mini' clearable filterable  @change='getTableData'  >
					    <el-option
					      v-for="item in reportFromList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					 <el-checkbox v-model="form.unallocated"  @change='getTableData'>仅看未分配</el-checkbox>
				</el-form-item>
				<el-form-item>
					 <el-button type='text' @click.stop='isScreenDialogShow?isScreenDialogShow=false:isScreenDialogShow=true'>高级筛选</el-button>
					 <transition name="el-zoom-in-top">
						<div class='screen_c' v-show='isScreenDialogShow' @click.stop='returnFalse'>
						 	<screen-dialog @formMessage = 'formMessage'></screen-dialog>
						</div>
					 </transition>
					 
				</el-form-item>
				<el-form-item class='fr'>
					<el-button size='mini' type="default" v-for='i in buttonList' :key='i.id' @click='handleButtonOperation(i)'>{{i.name}}</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 表格 -->
		<public-table :table="tableData" @onHandlePaginationChange="handlePaginationChange" style='margin-top: 10px;'>
			<template slot-scope="props" slot="wordnumber"> 
				<el-button type='text'
							@click="handleModify(props.scope.row)"
							>
					{{props.scope.row.wordnumber}}
				</el-button>
			</template>
			<template slot-scope="props" slot="buttons"> 
				<el-button type='text'
							v-for='i in props.scope.row.buttons'
							:key = 'i.id'
							@click="openDialog(props.scope.row)"
							>
					{{i.label}}
				</el-button>
			</template>
			<!-- <template slot-scope='props' slot='mark'>
				    <el-tooltip class="item" effect="light"  placement="bottom" slot="reference"
				     	:visible-arrow='false'
				     	v-if='props.scope.row.signReason'
				     	transition='null'
				    >
				     	<span slot='content'>{{(props.scope.row.signReason?props.scope.row.signReason:"无")}}</span>
				      <i  class='iconfont iconlastTime' :style='retunMarkStyle(props.scope.row)' 
				     @click.stop='clickPopoverShow(props.scope.row)'></i>
				    </el-tooltip>
				   	 <i  class='iconfont iconlastTime' :style='retunMarkStyle(props.scope.row)' 
				   	 v-if='!props.scope.row.signReason'
				   	 slot="reference"
				     @click.stop='clickPopoverShow(props.scope.row)'></i>
			</template> -->
		</public-table>
		<!-- 修改凭证  -->
		<edit-voucher :visible="XG_voucherShow" :row="rows" :openButton_s='openButton_s'
			@on-close-dialog="cancel($event,'edit')" @on-success-submit="successEdit"
			@successSaveMark='successSaveMark'
			v-if="XG_voucherShow">
		</edit-voucher>
		<!--现金流量配置-->
		<distribution-flow-dialog 
			:isFlowDialogShow.sync = 'isFlowDialogShow'
			:rowMessage = 'rows'
			@flowIds = 'flowIds'
		></distribution-flow-dialog>
	</div>
</template>

<script>
import screenDialog from "./components/screenDialog.vue"
import publicTable from '@/components/publicTable'
import {currencys} from '@/assets/utils/currencyFormat'
import editVoucher from '@/components/table/editVoucher'
import distributionFlowDialog from "@/components/dialog/distributionFlowDialog"
export default {
	components:{
		screenDialog,publicTable,editVoucher,distributionFlowDialog
	},
	data(){
		return {
			buttonList: [],  // 打印导出按钮权限
			markList:[
				{id:'1',color:'#999'},
				{id:'2',color:'green'},
				{id:'3',color:'#f5a623'},
				{id:'4',color:'#e5691f'},
				{id:'5',color:'#d0021b'},
			],
			isFlowDialogShow:false,  // 现金流量分配
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,		// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: true,	// 是否显示分页
				key: 0,						// 渲染Table
				config: [{
					label: '日期',
					value: 'date',
					width: 120,
					show: 'normal',

				},{
					label: '凭证字号',
					value: 'wordnumber',
					show: 'template',
					width:120,
				},{
					label: '摘要',
					value: 'summary',
					show: 'normal'
				},{
					label: '科目',
					value: 'subjectName',
					show: 'normal',
				},{
					label: '借方金额',
					value: 'debitMoney',
					show: 'normal',
					width:150,
				},{
					label: '贷方金额',
					value: 'creditorMoney',
					show: 'normal',
					width:150,
				},{
					label: '流量项目',
					value: 'reportFromName',
					show: 'normal'
				},{
					label: '制单人',
					value: 'createName',
					show: 'normal',
					width:120,
				},{
					label: '操作',
					value: 'buttons',
					show: 'template',
					width:120,
				}],
				operation: {
					label: '操作',
					value: 'operation',
					data: []
				},
				data: [],

				page: {
					pageNo: 1,
					pageSize: 10,
					count: 0
				},
				center: {
					textAlign: 'center',
					padding: '6px 0',
				},
				arraySpanMethod: this.arraySpanMethod,			// 自定义合并行
				tableRowClassName: this.tableRowClassName,		// 自定义hover效果
				cellMouseEnter: this.cellMouseEnter,		// 自定义鼠标移入
				cellMouseLeave: this.cellMouseLeave,		// 自定义鼠标移出
				handleSelect: this.handleSelect,		// 自定义鼠标移出
			},
			dataList:[],
			isScreenDialogShow:false,      // 高级筛选
			reportFromList:[],  // 项目集合
			objectList:[],    // 科目集合
			OrderIndexArr: [],      // 合并数据集合
			hoverOrderArr: [],    // 合并class  hover效果
			subjectList:"",
			form:{
				currentPage: 1,					// 当前页码
				maxResult: 10,				// 当前分页数
				startYearPeriods:"",  // 开始期数
				endYearPeriods:"",  // 结束期数
				summary:"",  // 摘要
				subjectId:"",  // 科目id
				unallocated:false,  // 0=仅看未分配 1=所有 
				createName:"",  // 制单人
				startMoney:"", // 开始金额
				endMoney:"",  // 结束金额
				signId:0,  // 标记颜色
				signReason:"",  // 标记原因
				reportFromId:"",  // 报表ID
				foreignCurrencyId:'', // 币种
			},
			XG_voucherShow:false,  // 修改凭证
			openButton_s: false,  // 是否打开翻页
			rows:{},  // 当前页
			isFirstActive:false,  //第一次进来
		}

	},

	created(){
		let yearStr = this.nowYearPeriod&&this.nowYearPeriod.toString().substring(0,4);
		let monthStr = this.nowYearPeriod&&this.nowYearPeriod.toString().substring(4);
		let str = yearStr + "-" + monthStr;
		this.dataList = [str,str]
		this.getButton();
		this.getFlowList();
		this.getflowSunject();
		this.getTableData();
	},
	mounted(){

	},
	computed:{
		nowYearPeriod() {
			return JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod;
		},
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		}
	},
	activated() {
		if(this.getClickCache&&this.isFirstActive) {
			this.getTableData();
		}
		this.isFirstActive = true;
	},
	methods:{
		// 打印&&导出
		handleButtonOperation(row) {
			let params = JSON.parse(JSON.stringify(this.form));
				params.startYearPeriods = this.$util.formatDate.format(this.dataList[0] , 'yyyyMM');
				params.endYearPeriods = this.$util.formatDate.format(this.dataList[1] , 'yyyyMM');
				params.unallocated = params.unallocated?0:1;
				params.subjectId = this.subjectList.toString();
				params = Object.assign(params, {
						cid: sessionStorage.cid,
						token: sessionStorage.token,
					})
				if(row.permission == "ac:cashflow:print") {  // 打印
					const router = this.$router.resolve({
						path: '/createPDF/printFlowSummary',
						query: params
					})
					window.open(this.$rootUrl + router.href, '_blank')
				}else if(row.permission == "ac:cashflow:export"){  // 导出
					const routers =this.$router.resolve({
			          path: '/export/exportFlowSummary',
			          query: params
			        })
			         window.location.href = this.$rootUrl + routers.href;
				}else {
					this.$message.warning('按钮操作无内容响应，请联系开发人员！')
				}
		},
		// 获取按钮权限
		getButton(){
			let params={
				permissions:'ac:cashflow:export,ac:cashflow:print'
			}
			try {
				this.$http.post('sys/menu/findPermissionMenu' , params).then(res=>{
					if(res && res.data.code == 1) {
						if(res.data.data.length){
							this.buttonList = res.data.data;
						}
					}
				})
			}catch(e){
			}
		},
		// 翻页
		handlePaginationChange (data) {
			const { pageNo, pageSize } = data;

			if (pageNo) {
				this.$set(this.form, 'currentPage', pageNo);
				this.$set(this.tableData.page, 'pageNo', pageNo);
			}

			if (pageSize) {
				this.$set(this.form, 'maxResult', pageSize);
				this.$set(this.tableData.page, 'pageSize', pageSize);
			}
			this.getTableData();
		},
		// 操作标记点击
		clickPopoverShow(row) {
			const _ = this;
			this.nowRowClickData = row;
			row.isPopoverShow = !row.isPopoverShow;
		},
		// 返回标记颜色
		retunMarkStyle(row) {
			let params = {
				fontSize:"20px",
				cursor:"pointer",
				color:"",
			}

			switch(row.signId) {
				case '1':
					params.color='#999';
					break;
				case '2':
					params.color='green';
					break;
				case '3':
					params.color='#f5a623';
					break;
				case '4':
					params.color='#e5691f';
					break;
				case '5':
					params.color='#d0021b';
					break;
			}
			return params
		},
		// 获取流量项目
		getFlowList() {
			let params = {
				yearPeriods: JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod
			}
			this.$http.post('reportform/getCashFlowFrom',params).then(res=>{
	            if(res && res.data.code == 1) {
	             	 this.reportFromList = res.data.data;
	            }
	        })
		},
		// 现金流量科目
		getflowSunject() {
			this.$http.post('reportform/getFlowSubject' , {}).then(res=>{
				if(res && res.data.code == 1) {
					this.objectList = res.data.data;
				}
			})
		},
		// 修改流量分配返回
		flowIds(data) {
			let params = {
				addendumId:this.rows.addendumId,   // 凭证分录ID
				cashFlowIds:data,  // 流量ID,多个,号隔开
				yearPeriods:this.rows.yearPeriods,  // 期数
			}
			this.$http.post('reportform/updateCashFlowFrom' , params).then(res=>{
				if(res.data && res.data.code == 1) {
					this.$message.success('修改成功！')
					this.getTableData();
				}
			})
		},
		// 打开流量分配
		openDialog(row) {
			row.id = row.voucherId;
			if(row.creditorMoney) {
				row.creditorMoney = row.creditorMoney.replace(/\,/g,"");
			}
			if(row.debitMoney) {
				row.debitMoney = row.debitMoney.replace(/\,/g,"");
			}
			this.rows = row;
			this.isFlowDialogShow = true
		},
		// 取消修改凭证
		cancel(val,key){
			this.XG_voucherShow = val;
			this.openButton_s = false;
			if(key){

			}else{
				this.getTableData();
			}
		},
		// 列表修改操作
		handleModify(row){
			const _=this;
			_.XG_voucherShow = true;
			row.id = row.voucherId;
			_.rows = row;
			_.openButton_s = true;
		},
		//  设置行hover效果
		tableRowClassName({row}) {
			 let array = this.hoverOrderArr
			for (var i = 0; i < array.length; i++) {
	          if (row.addendumId == array[i].addendumId) {
	            return 'success-row'
	          }
	        }
		},
		// 鼠标进入事件
		 cellMouseEnter(row, column, cell, event) {
		 	this.hoverOrderArr = [];
		 	this.OrderIndexArr.forEach(i=>{
		 		let arr = i.find(item=>{return item.addendumId == row.addendumId});
		 		if(this.hoverOrderArr.indexOf(arr)<0) {
		 			if(arr) {
		 				this.hoverOrderArr.push(arr);
		 			}
		 		}
		 	})
	      },
	    // 鼠标移出事件
	     cellMouseLeave: function (row, column, cell, event) {
	        this.hoverOrderArr = [];
	     },
		// 合并
		arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (columnIndex < 6 || columnIndex > 6) {
				if (row.rows) {
					return {
						rowspan: row.rows,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		// 子组件标记
		successSaveMark(data) {
			if(data) {
				this.getTableData()
			}
		},
		successEdit(val){//修改成功后的回调
			if(val){
				this.getTableData();
			}
		},
		// 查询凭证
		getTableData() {
			this.tableData.loading = true;
			let params = {
				...this.form
			}
			params.startYearPeriods = this.$util.formatDate.format(this.dataList[0] , 'yyyyMM');
			params.endYearPeriods = this.$util.formatDate.format(this.dataList[1] , 'yyyyMM');
			params.unallocated = params.unallocated?0:1;
			params.subjectId = this.subjectList.toString();
			this.$http.post('reportform/getFlowSummary' , params).then(res=>{
				this.tableData.loading = false;
				if(res.data.code==1) {
					let datas = res.data.data.list;
					let arr = [] , num = 0 , addendumId = datas.length&&datas[0].addendumId;
					this.tableData.page.count = parseInt(res.data.data.totalCount);
					this.tableData.page.pageNo = parseInt(res.data.data.currentPage);
					this.tableData.data = res.data.data.list.map((item,index)=>{
						item.allSelect = false;
						item.signId = item.signId?item.signId.toString():"";
						item.signId_c = item.signId;
						item.signReason_c = item.signReason;
						item.isPopoverShow = false;
						// 格式化金额
						if(item.debitMoney!=0 ){
							item.debitMoney = currencys(item.debitMoney);
						}
						if(item.creditorMoney!=0 ){
							item.creditorMoney = currencys(item.creditorMoney);
						}
						// 借方金额贷方金额为0不显示
						for (let key in item) {
							if (key == 'debitMoney' || key == 'creditorMoney') {
								item[key] = item[key] || '';
							}
						}
						if(item.addendumId == addendumId) {
							arr.push(item);
						}else {
							arr = [],
							arr.push(item);
							num = index;
							addendumId = datas[num].addendumId;
						}
						datas[num].rows=arr.length;
						if(arr.length>1) {
							this.OrderIndexArr.push(arr);
						}
						return item;
					})
				}
			})
		},
		formMessage(data) {
			this.form = Object.assign(this.form,{...data});
			this.getTableData();
		},
		// 点击空白页消失
		clickBody() {
			this.isScreenDialogShow = false;
		},
		returnFalse() {
			return false
		}
	},
	watch: {
		isScreenDialogShow(val){
			val?document.body.addEventListener('click', this.clickBody):document.body.removeEventListener('click', this.clickBody)
		}
	},
	deactivated(){
		
	}
}
</script>

<style lang="less">
	#getFlowSummary {
		.el-checkbox__input.is-disabled .el-checkbox__inner {
			background: #ddd;
			border-color: #ddd;
		}
		.itemPublic {
			width: 180px;
		}
		.screen_c {
			position: absolute;
			z-index: 2;
			left: -328px;
		}
		.titleName {
			color: #4A4A4A;
			font-weight: 600;
		}
		.screen_wrapper {
			margin-top: 15px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/voucher/getFlowSummary.vue